module.exports = __webpack_public_path__ + "img/video_fallback_onboarding.ad0cb133.webp";